import { useQuery } from "@tanstack/react-query";
import { getCalendarNominalDays } from "PFCore/services/booking_config";
import { Collection } from "PFTypes";
import { NominalDay } from "PFTypes/booking/booking_config";
import { QueryOptions } from "PFTypes/request_options";

import { bookingConfigKeys } from "./query_keys";

export const useNominalDaysQuery = (calendarId: string, options?: QueryOptions<Collection<NominalDay[]>>) =>
  useQuery<Collection<NominalDay[]>>(
    bookingConfigKeys.nominalDays(calendarId),
    () => getCalendarNominalDays(calendarId),
    options
  );
